import React from 'react';
import _ from 'lodash';

import { FormElement } from './CommonFormComponents';
import { stringToDate } from '../utilities/validateDateUtil';
import { TAB_KEY_STATUS } from '../utilities/constants';

/**
 *
 * @props {Boolean} isPreview
 * @props {Boolean} disabled
 * @props {String} dateString: 日付
 * @props {String} showPlaceholder: 年月日で同じプロパティを使用しているので分割して設定したい場合は修正が必要
 * @props {String} message: バリデーションエラーメッセージ
 * @props {String} warning: 警告メッセージ
 * @props {String} info: 補助メッセージ
 * @props {Element} ccusComponent
 * @props {Function} onBlur: onBlurメソッド
 * @props {Function} onChangeValue: onChangeメソッド
 * @props {String} tabKeyStatus: Tab操作を有効にするフラグ "-1":無効 "0":有効
 */
export class DateInput extends React.Component {
  constructor(props) {
    super(props);
    const [year, month, day] = stringToDate(this.props.dateString);
    this.state = {
      year,
      month,
      day,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.dateString !== this.props.dateString) {
      const [year, month, day] = stringToDate(this.props.dateString);
      this.setState({
        year,
        month,
        day,
      });
    }
  }

  handleYearOnChange = e => {
    const { value } = e.target;
    const { month, day } = this.state;
    if (value.split('').pop() === '/') {
      return;
    }
    this.setState({ year: value });
    if (_.isFunction(this.props.onChangeValue)) {
      this.props.onChangeValue(`${value}/${month}/${day}`);
    }
  };

  handleMonthOnChange = e => {
    const { value } = e.target;
    const { year, day } = this.state;
    if (value.split('').pop() === '/') {
      return;
    }
    this.setState({ month: value });
    if (_.isFunction(this.props.onChangeValue)) {
      this.props.onChangeValue(`${year}/${value}/${day}`);
    }
  };

  handleDayOnChange = e => {
    const { value } = e.target;
    const { year, month } = this.state;
    if (value.split('').pop() === '/') {
      return;
    }
    this.setState({ day: value });
    if (_.isFunction(this.props.onChangeValue)) {
      this.props.onChangeValue(`${year}/${month}/${value}`);
    }
  };

  onBlur = e => {
    if (_.isFunction(this.props.onBlur)) {
      this.props.onBlur(e);
    }
  };

  getYearInput = () =>
    this.props.isPreview ? (
      <span>{this.state.year}</span>
    ) : (
      <input
        type='text'
        name='year'
        placeholder={this.props.showPlaceholder && '1970'}
        disabled={this.props.disabled}
        value={this.state.year}
        onChange={this.handleYearOnChange}
        onBlur={this.onBlur}
        maxLength='4'
        className='input-date__year'
        tabIndex={this.props.tabKeyStatus || TAB_KEY_STATUS.enabled}
      />
    );

  getMonthInput = () =>
    this.props.isPreview ? (
      <span>{this.state.month}</span>
    ) : (
      <input
        type='text'
        name='month'
        placeholder={this.props.showPlaceholder && '01'}
        disabled={this.props.disabled}
        value={this.state.month}
        onChange={this.handleMonthOnChange}
        onBlur={this.onBlur}
        maxLength='2'
        className='input-date__month'
        tabIndex={this.props.tabKeyStatus || TAB_KEY_STATUS.enabled}
      />
    );

  getDayInput = () =>
    this.props.isPreview ? (
      <span>{this.state.day}</span>
    ) : (
      <input
        type='text'
        name='day'
        placeholder={this.props.showPlaceholder && '01'}
        disabled={this.props.disabled}
        value={this.state.day}
        onChange={this.handleDayOnChange}
        onBlur={this.onBlur}
        maxLength='2'
        className='input-date__day'
        tabIndex={this.props.tabKeyStatus || TAB_KEY_STATUS.enabled}
      />
    );

  render() {
    const { jpDelimiterChar } = this.props;
    return (
      <FormElement
        validate={!_.isEmpty(this.props.message) && this.props.message}
        ccusComponent={this.props.ccusComponent}
        warning={this.props.warning}
        info={this.props.info}
        {...this.props}
      >
        {this.props.isPreview && !this.props.dateString ? null : (
          <div className='input-date'>
            {this.getYearInput()}
            {jpDelimiterChar ? '年' : '/'}
            {this.getMonthInput()}
            {jpDelimiterChar ? '月' : '/'}
            {this.getDayInput()}
            {jpDelimiterChar ? '日' : ''}
          </div>
        )}
      </FormElement>
    );
  }
}

export class DateInputYearMonth extends React.Component {
  constructor(props) {
    super(props);
    const [year, month] = stringToDate(this.props.dateString);
    this.state = {
      year,
      month,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.dateString !== this.props.dateString) {
      const [year, month] = stringToDate(this.props.dateString);
      this.setState({
        year,
        month,
      });
    }
  }

  handleYearOnChange = e => {
    const { value } = e.target;
    const { month } = this.state;
    if (value.split('').pop() === '/') {
      return;
    }
    this.setState({ year: value });
    if (_.isFunction(this.props.onChangeValue)) {
      this.props.onChangeValue(`${value}/${month}`);
    }
  };

  handleMonthOnChange = e => {
    const { value } = e.target;
    const { year } = this.state;
    if (value.split('').pop() === '/') {
      return;
    }
    this.setState({ month: value });
    if (_.isFunction(this.props.onChangeValue)) {
      this.props.onChangeValue(`${year}/${value}`);
    }
  };

  onBlur = e => {
    if (_.isFunction(this.props.onBlur)) {
      this.props.onBlur(e);
    }
  };

  getYearInput = () =>
    this.props.isPreview ? (
      <span>{this.state.year}</span>
    ) : (
      <input
        type='text'
        name='year'
        disabled={this.props.disabled}
        value={this.state.year}
        onChange={this.handleYearOnChange}
        onBlur={this.onBlur}
        maxLength='4'
        className='input-date__year'
        data-testid='date-input-year'
      />
    );

  getMonthInput = () =>
    this.props.isPreview ? (
      <span>{this.state.month}</span>
    ) : (
      <input
        type='text'
        name='month'
        disabled={this.props.disabled}
        value={this.state.month}
        onChange={this.handleMonthOnChange}
        onBlur={this.onBlur}
        maxLength='2'
        className='input-date__month'
        data-testid='date-input-month'
      />
    );

  render() {
    const { jpDelimiterChar } = this.props;
    return (
      <FormElement
        ccusComponent={this.props.ccusComponent}
        validate={!_.isEmpty(this.props.message) && this.props.message}
        warning={this.props.warning}
        info={this.props.info}
      >
        <div className='input-date'>
          {this.getYearInput()}
          {jpDelimiterChar ? '年' : '/'}
          {this.getMonthInput()}
          {jpDelimiterChar ? '月' : '/'}
        </div>
      </FormElement>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DateInput.jsx